import { HeatmapAggregationFn } from '@warebee/shared/common';
import { getAggregatedFunction } from './simulationHqMetricCommon';
import {
  getSimulationHqQueryBuilder,
  SimulationHqDataColumn,
  SimulationHqQueryBuilderParams,
} from './simulationHqQueryBuilder';

export type GetSimulationHqMetricSummaryParams =
  SimulationHqQueryBuilderParams & {
    groupBy: SimulationHqDataColumn;
    aggregationFn: HeatmapAggregationFn;
    aggregateBy: SimulationHqDataColumn;
  };

export function getSimulationHqMetricSummary(
  params: GetSimulationHqMetricSummaryParams,
) {
  return (
    getSimulationHqQueryBuilder(params)
      .with(
        cte => cte('metricData'),
        db => {
          let queryBase = db
            .selectFrom('hq')
            .select(({ fn }) => [
              'locationId',
              'skuKey',
              'locationLevel',
              'layoutLocationId',
              'assignmentItem',
            ]);
          let query = getAggregatedFunction(
            queryBase,
            params.aggregationFn,
            params.groupBy,
          ).groupBy([
            'locationId',
            'skuKey',
            'locationLevel',
            'layoutLocationId',
            'assignmentItem',
          ]);
          return query;
        },
      )
      // .with(
      //   cte => cte('aggregated'),
      //   db => {
      //     let queryBuilder = db
      //       .selectFrom('hq')
      //       .select(({ fn }) => [
      //         'assignmentItem',
      //         'skuKey',
      //         'locationLevel',
      //         fn.countAll<number>().as('totalEvents'),
      //         fn.count<number>('locationId').distinct().as('totalLocations'),
      //         fn
      //           .count<number>('layoutLocationId')
      //           .distinct()
      //           .as('totalExistedLocations'),
      //         fn.count<number>('skuKey').distinct().as('totalItems'),
      //         fn
      //           .count<number>('assignmentItem')
      //           .distinct()
      //           .as('totalAssignments'),
      //       ])
      //       .groupBy(['assignmentItem', 'skuKey', 'locationLevel']);

      //     let queryBuilder2 = getAggregatedFunction(
      //       queryBuilder,
      //       params.aggregationFn,
      //       params.groupBy,
      //     );
      //     return queryBuilder2;
      //   },
      // )

      .selectFrom('metricData')
      .select(({ fn, ref }) => [
        ref('dimensionValue').as('dimension'),
        'locationLevel',
        fn.countAll<number>().as('totalCount'),
        fn.countAll<number>().as('totalLines'),
        fn.count<number>('locationId').distinct().as('totalLocations'),
        fn
          .count<number>('layoutLocationId')
          .distinct()
          .as('totalExistedLocations'),
        fn.count<number>('skuKey').distinct().as('totalItems'),
        fn.count<number>('assignmentItem').distinct().as('totalAssignments'),
      ])
      .groupBy(['dimensionValue', 'locationLevel'])
  );
}
